import $ from "jquery";
import m from "../../prime-src/prepare";

export default function ButtonsFloating() {
	return (
		<>
			<div id="floating-key">
				<div id="button-hideFK" className="button" onClick={() => m.hideFK()}>
					<div className="inline">▼ Hid</div><div className="inline bold underline">e</div><div className="inline"></div>
					</div>
				{m.myIndex === ""
				? <div className="button darkred">
					<a className="a-log-in" href="/account/log-in">
						<div className="inline">Log </div><div className="inline bold underline">i</div><div className="inline">n</div>/<div className="inline">S</div><div className="inline bold underline">i</div><div className="inline">gn up</div>
						</a>
				</div>
				: <>
					<div className={`button${m.myPage ? ` enabled` : ` cadetblue`}`}>Your id: {m.escapeOnlyTag(m.myId)}</div>
					<div className="button darkred">
						<a className="a-log-out" href="/account/log-out">
							<div className="inline">Log </div><div className="inline bold underline">o</div><div className="inline">ut</div>
							</a>
					</div>
				</>}
				{!m.myPage && m.myId
				? <div className="button cadetblue">
					<a id="a-to-my-page" href={`/user/${m.myId}`}>
						<div className="inline">To my p</div><div className="inline bold underline">a</div><div className="inline">ge</div>
						</a></div>
					: ""}
				<div className="button button-block-touch" onClick={() => m.$window.trigger({ type: 'keydown', code: 'KeyU' } as any)}>
					<div className="inline">Block to</div><div className="inline bold underline">u</div><div className="inline">ch</div>
				</div>
				<div className="inline point-range-result">0~10/10</div>
				<div className="point-range-con">
					<div className="point-range">
						<div className="point-range-bar"></div>
						<div className="point-range-right"></div>
						<div className="point-range-left"></div>
					</div>
				</div>
				<div className="button button-mode button-neighbors-mode" onClick={() => m.$window.trigger({ type: 'keydown', code: 'KeyB' } as any)}>
					<div className="inline">Neigh</div><div className="inline bold underline">b</div><div className="inline">ors mode</div>
				</div>
				{m.myPage
				? <>
					<div className="button button-mode button-get-recoms" onClick={() => m.$window.trigger({ type: 'keydown', code: 'KeyR' } as any)}>
						<div className="inline">Get </div><div className="inline bold underline">R</div><div className="inline">ecoms</div>
					</div>
					<div className="button button-mode button-daily-mix" onClick={() => m.$window.trigger({ type: 'keydown', code: 'KeyY' } as any)}>
						<div className="inline">Dail</div><div className="inline bold underline">y</div><div className="inline"> Mix</div>
					</div>
				</>
				: ``}
				<div className="button button-mode button-multireco-mode" onClick={() => m.$window.trigger({ type: 'keydown', code: 'KeyM' } as any)}>
					<div className="inline"></div><div className="inline bold underline">M</div><div className="inline">ultireco mode</div>
				</div>
				<div className="button button-Go" style={{borderRight:"none"}} onClick={() => m.$window.trigger({ type: 'keydown', code: 'KeyG' } as any)}>
					<div className="inline"></div><div className="inline bold underline">G</div><div className="inline">o (FS)</div>
				</div>
				<div className="button button-ToR" onClick={() => m.$window.trigger({ type: 'keydown', code: 'KeyT' } as any)}>
					<div className="inline"></div><div className="inline bold underline">T</div><div className="inline">ofR</div>
				</div>
				<div className="button darkgoldenrod" onClick={() => m.$window.trigger({ type: 'keydown', code: 'KeyZ' } as any)}>
					<div className="inline">To List Play(</div><div className="inline bold underline">Z</div><div className="inline">)</div>
				</div>
				<div className="button darkgoldenrod" onClick={() => m.$window.trigger({ type: 'keydown', code: 'KeyX' } as any)}>
					<div className="inline">To Contents(</div><div className="inline bold underline">X</div><div className="inline">)</div>
				</div>
				<div className="button darkgoldenrod" onClick={() => m.$window.trigger({ type: 'keydown', code: 'KeyD' } as any)}>
					<div className="inline">Backwar</div><div className="inline bold underline">d</div><div className="inline"></div>
				</div>
				<div className="button darkgoldenrod" onClick={() => m.$window.trigger({ type: 'keydown', code: 'KeyF' } as any)}>
					<div className="inline"></div><div className="inline bold underline">F</div><div className="inline">orward</div>
				</div>
				<div className="button button-goto-cats" onClick={() => m.$window.trigger({ type: 'keydown', code: 'KeyC' } as any)}>
					<div className="inline">Go to </div><div className="inline bold underline">C</div><div className="inline">ats</div>
				</div>
				<div className="button button-new-reco" onClick={() => m.$window.trigger({ type: 'keydown', code: 'KeyN' } as any)}>
					<div className="inline"></div><div className="inline bold underline">N</div><div className="inline">ew reco</div>
				</div>
				<div id="SNS-floating"><img className="SNS-img" src="/CDN/link.png" onClick={() => m.shareCurrentPage('link')}/><img className="SNS-img" src="/CDN/icon-Tag.png" onClick={() => m.shareCurrentPage('tag')}/><img className="SNS-img" src="/CDN/icon-Recoeve.png" onClick={() => m.shareCurrentPage('recoeve')}/><img className="SNS-img" src="/CDN/icon-X.png" onClick={() => m.shareCurrentPage('X')}/><img className="SNS-img" src="/CDN/icon-Facebook.png" onClick={() => m.shareCurrentPage('facebook')}/><img className="SNS-img" src="/CDN/icon-Kakao.png" onClick={() => m.shareCurrentPage('kakao')}/><img className="SNS-img" src="/CDN/icon-Whatsapp.png" onClick={() => m.shareCurrentPage('whatsapp')}/></div>
			</div>
			<div className="button" id="toggle-floating-key" onClick={() => m.toggleFK()}>▲</div>
		</>
	);
}
